import { useTheme } from 'emotion-theming';
import Highlighter from 'react-highlight-words';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
    searchResultLinkCSS,
    searchResultLinkCustomerCategoryCSS,
    searchResultLinkProductCategoryCSS,
} from './styles/RevStatsSearchResultLink.styles';
import getTagCharacterForRevStatsSearchLink from '../../services/getTagCharacterForRevStatsSearchLink';

export default function RevStatsSearchResultLink({ category, className, label, searchWords, url }) {
    const theme = useTheme();
    const tagStyling = [
        category === 'customer' && searchResultLinkCustomerCategoryCSS(theme),
        category === 'product' && searchResultLinkProductCategoryCSS(theme),
    ];

    return (
        <Link className={className} css={searchResultLinkCSS} to={url} reloadDocument>
            <span css={tagStyling}>{getTagCharacterForRevStatsSearchLink(category)}</span>
            <Highlighter
                searchWords={searchWords ?? []}
                highlightTag="strong"
                autoEscape
                textToHighlight={label}
            />
        </Link>
    );
}

RevStatsSearchResultLink.propTypes = {
    category: PropTypes.string,
    className: PropTypes.string,
    label: PropTypes.string.isRequired,
    searchWords: PropTypes.arrayOf(PropTypes.string),
    url: PropTypes.string,
};
